import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Title, TextBody } from 'web-ui-components/lib/atoms/text';
import PatternLibModalComponent from '../../common/modals/PatternLibModalComponent';

export const ModalBody = ({ content }) => {
  return (
    <div className="web-ui-components c-centered-group">
      <Title size="h4">{content.preferencesUpdateErrorTitle}</Title>`
      <TextBody className="u-text-align-center">
        {content.preferencesUpdateErrorBody1}
      </TextBody>
      <TextBody className="u-text-align-center">
        {content.preferencesUpdateErrorBody2}
      </TextBody>
    </div>
  );
};

export const ModalFooter = ({ onOkClick }) => (
  <div className="web-ui-components c-centered-group">
    <Button tabIndex="0" display="primary" onClick={onOkClick}>
      Ok
    </Button>
  </div>
);

export const ErrorModal = ({ show, content, onOkCLick }) => (
  <PatternLibModalComponent
    show={show}
    onHide={onOkCLick}
    bsSize={'medium'}
    modalBody={<ModalBody content={content} />}
    modalFooter={<ModalFooter onOkClick={onOkCLick} />}
    customClass={'c-modal'}
    closeButton={false}
    backdrop="static"
  />
);

ErrorModal.propTypes = {
  onHide: PropTypes.func,
  show: PropTypes.bool,
  content: PropTypes.object,
  onOkCLick: PropTypes.func,
};

ModalBody.propTypes = {
  content: PropTypes.shape({
    preferencesUpdateErrorTitle: PropTypes.string,
    preferencesUpdateErrorBody1: PropTypes.string,
    preferencesUpdateErrorBody2: PropTypes.string,
  }),
};

ModalFooter.propTypes = {
  onOkClick: PropTypes.func,
};
